// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"83637414","453":"fe7581dc"}[chunkId] + ".chunk.js";
};